import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { PageLayout } from '@cvx/nextpage';
import { AttestationService, AttestationCampaignSummary } from 'src/app/services/attestation/Attestation.service';

@Component({
    selector: 'app-my-attestations',
    templateUrl: './my-attestations.component.html'
})
export class MyAttestationsComponent implements OnInit {

    PageLayout = PageLayout;
    isLoading = true;
    loadError: string;
    campaigns: AttestationCampaignSummary[] = [];
    statusFilter: string = 'All';
    pageSize = 10;
    filterOpen = false;

    readonly filterOptions = ['All', 'Pending', 'In Progress', 'Complete'];

    @HostListener('document:click')
    closeFilter() { this.filterOpen = false; }

    toggleFilter(e: MouseEvent) { e.stopPropagation(); this.filterOpen = !this.filterOpen; }

    pickFilter(f: string) { this.setFilter(f); this.filterOpen = false; }

    get filteredCampaigns(): AttestationCampaignSummary[] {
        switch (this.statusFilter) {
            case 'Pending':     return this.campaigns.filter(c => c.status === 'Pending');
            case 'In Progress': return this.campaigns.filter(c => c.status === 'InProgress');
            case 'Complete':    return this.campaigns.filter(c => c.status === 'Complete');
            default:            return this.campaigns;
        }
    }

    get pagedCampaigns(): AttestationCampaignSummary[] {
        return this.filteredCampaigns.slice(0, this.pageSize);
    }

    setFilter(f: string): void {
        this.statusFilter = f;
        this.pageSize = 10;
    }

    showMore(): void {
        this.pageSize += 10;
    }

    constructor(
        private attestationService: AttestationService,
        private router: Router
    ) {}

    async ngOnInit() {
        try {
            this.campaigns = await this.attestationService.getMyCampaigns();
        } catch {
            this.loadError = 'Failed to load your attestation campaigns. Please try again.';
        } finally {
            this.isLoading = false;
        }
    }

    review(campaign: AttestationCampaignSummary): void {
        this.router.navigate(['/attest'], {
            queryParams: { campaignId: campaign.campaignId, spObjectId: campaign.servicePrincipalObjectId }
        });
    }

    statusLabel(status: string): string {
        if (status === 'InProgress') return 'In Progress';
        return status;
    }

    statusStyle(status: string): { [key: string]: string } {
        switch (status) {
            case 'Pending':    return { background: '#fff3cd', color: '#856404' };
            case 'InProgress': return { background: '#dbeafe', color: '#1d4ed8' };
            case 'Complete':   return { background: '#dcfce7', color: '#15803d' };
            default:           return { background: '#f3f4f6', color: '#374151' };
        }
    }
}
